import React, { ReactElement } from "react";
import Layout from "../../components/layout";
import Neighborhood from "../../components/Neighborhood";

const NeighborhoodPage = (): ReactElement => {
  return (
    <Layout>
      <Neighborhood />
    </Layout>
  );
};

export default NeighborhoodPage;
